export default function Footer() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-900 text-background-300">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <h4 className="text-background-50 font-heading text-lg mb-4">羞羞歪歪漫画</h4>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              羞羞歪歪漫画全集免费阅读平台，全部章节无删减，支持下拉式竖屏阅读。每日同步更新最新章节，在线看入口免费直达。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" className="w-9 h-9 rounded-lg bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#hero" className="w-9 h-9 rounded-lg bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#hero" className="w-9 h-9 rounded-lg bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-background-50 text-sm font-medium mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#media" onClick={(e) => handleScroll(e, '#media')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">精彩视频</a>
              </li>
              <li>
                <a href="#ranking" onClick={(e) => handleScroll(e, '#ranking')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热门排行</a>
              </li>
              <li>
                <a href="#index" onClick={(e) => handleScroll(e, '#index')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">主题索引</a>
              </li>
              <li>
                <a href="#topics" onClick={(e) => handleScroll(e, '#topics')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热门话题</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 text-sm font-medium mb-4">帮助中心</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#faq" onClick={(e) => handleScroll(e, '#faq')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">常见问题</a>
              </li>
              <li>
                <a href="#contact" onClick={(e) => handleScroll(e, '#contact')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">联系我们</a>
              </li>
              <li>
                <a href="#about" onClick={(e) => handleScroll(e, '#about')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">关于我们</a>
              </li>
              <li>
                <a href="#updates" onClick={(e) => handleScroll(e, '#updates')} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">更新动态</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 text-sm font-medium mb-4">合作伙伴</h4>
            <ul className="space-y-2.5">
              <li>
                <span className="text-sm text-background-500">更多合作伙伴即将入驻</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 羞羞歪歪漫画. 本站所有漫画内容仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#hero" className="hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
            <a href="#hero" className="hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">用户协议</a>
            <a href="#hero" className="hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}